import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Box } from "@mui/system";
import {
  FormControl,
  FormHelperText,
  Grid,
  Typography,
  Autocomplete,
} from "@mui/material";
import {
  StyledTextField,
} from "../../../customComponents/styled/styledInputs";
import { StyledLoadingButton } from "../../../customComponents/styled/styledButtons";
import { useUpdateSectionMutation } from "./sectionsApiSlice";
import toast from "../../../../helpers/toast";
import { useGetTeachersPaginatedQuery } from "../../staff/staffApiSlice";

const sectionFormValidation = yup.object({
  name: yup.string().required("Required"),
  head_title: yup.string().required("Required"),
});

function EditSectionForm({ item, setFocusedItem }) {
  const [updateSection, { isLoading }] = useUpdateSectionMutation();
  const [teacherSearch, setTeacherSearch] = React.useState("");
  const { data: teachersData } = useGetTeachersPaginatedQuery({ page: 1, per_page: 10, q: teacherSearch });
  const teachers = teachersData?.teachers ?? [];

  const sectionForm = useFormik({
    initialValues: {
      id: item?.id,
      name: item?.name,
      head_title: item?.head_title,
      head_id: item?.head_id,
    },
    enableReinitialize: true,
    validationSchema: sectionFormValidation,
    onSubmit: async (values) => {
      try {
        await updateSection(values).unwrap();
        toast.success("Section updated successfully");
        sectionForm.resetForm();
        setFocusedItem(null);
      } catch (error) {}
    },
  });

  return (
    <>
      <Box className="paperHeader">
        <Typography variant="formHeading">Edit Section</Typography>
      </Box>
      <Box className="paperBody">
        <form onSubmit={sectionForm.handleSubmit}>
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid item xs={12}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">Section Name</Typography>
                <StyledTextField
                  autoFocus
                  variant="outlined"
                  id="name"
                  name="name"
                  value={sectionForm.values.name}
                  onChange={sectionForm.handleChange}
                  error={
                    sectionForm.touched.name && Boolean(sectionForm.errors.name)
                  }
                />
                <FormHelperText variant="error">
                  {sectionForm.touched.name && sectionForm.errors.name}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">
                  HEAD'S TITLE (E.G: HEAD TEACHER)
                </Typography>
                <StyledTextField
                  variant="outlined"
                  id="head_title"
                  name="head_title"
                  value={sectionForm.values.head_title}
                  onChange={sectionForm.handleChange}
                  error={
                    sectionForm.touched.head_title &&
                    Boolean(sectionForm.errors.head_title)
                  }
                />
                <FormHelperText variant="error">
                  {sectionForm.touched.head_title &&
                    sectionForm.errors.head_title}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <Typography htmlFor="head_id" variant="formSubHeading">
                  SELECT STAFF
                </Typography>
                <Autocomplete
                  options={teachers}
                  getOptionLabel={(option) => option ? `${option.first_name} ${option.last_name}` : ""}
                  isOptionEqualToValue={(option, value) => option.user_id === value.user_id}
                  value={teachers.find((t) => t.user_id === sectionForm.values.head_id) || null}
                  onChange={(_, value) => sectionForm.setFieldValue("head_id", value?.user_id || "")}
                  onInputChange={(_, value, reason) => { if (reason === "input") setTeacherSearch(value); }}
                  filterOptions={(x) => x}
                  renderInput={(params) => (
                    <StyledTextField
                      {...params}
                      placeholder="Search staff..."
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} textAlign={"right"}>
              <StyledLoadingButton loading={isLoading} type="submit">
                update
              </StyledLoadingButton>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
}

export default EditSectionForm;
